import { render, staticRenderFns } from "./leftmenujuegos.vue?vue&type=template&id=e4203aa6&"
import script from "./leftmenujuegos.vue?vue&type=script&lang=js&"
export * from "./leftmenujuegos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports